import "@/App.css";
import { Analytics } from "@vercel/analytics/react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import CookieConsent from "@/components/layout/CookieConsent";
import Hero from "@/components/sections/Hero";
import PainPoints from "@/components/sections/PainPoints";
import SolutionOverview from "@/components/sections/SolutionOverview";
import ValueStack from "@/components/sections/ValueStack";
import FeaturesGrid from "@/components/sections/FeaturesGrid";
import ComparisonTable from "@/components/sections/ComparisonTable";
import SocialProof from "@/components/sections/SocialProof";
import Pricing from "@/components/sections/Pricing";
import FAQ from "@/components/sections/FAQ";
import FinalCTA from "@/components/sections/FinalCTA";
import FeaturesPage from "@/pages/FeaturesPage";
import PricingPage from "@/pages/PricingPage";
import SignupPage from "@/pages/SignupPage";
import SignupConfirmation from "@/pages/SignupConfirmation";

function HomePage() {
  return (
    <>
      <Hero />
      <PainPoints />
      <SolutionOverview />
      <ValueStack />
      <FeaturesGrid />
      <ComparisonTable />
      <SocialProof />
      <Pricing />
      <FAQ />
      <FinalCTA />
    </>
  );
}

function PlaceholderPage({ title, description, testId }) {
  return (
    <div
      data-testid={testId}
      className="min-h-screen flex items-center justify-center bg-[#F9FAFB] pt-20"
    >
      <div className="text-center space-y-4 p-8">
        <h1 className="font-heading text-3xl font-bold text-[#1A1A1A]">
          {title}
        </h1>
        <p className="text-[#6B7280] text-base">{description}</p>
      </div>
    </div>
  );
}

// Routes that should not have the shared Header/Footer
const BARE_ROUTES = ["/signup", "/signup/confirmation"];

function AppLayout() {
  const location = useLocation();
  const isBare = BARE_ROUTES.some(
    (r) => location.pathname === r || location.pathname === r + "/"
  );

  if (isBare) {
    return (
      <Routes>
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/signup/confirmation" element={<SignupConfirmation />} />
      </Routes>
    );
  }

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/features" element={<FeaturesPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route
            path="/login"
            element={
              <PlaceholderPage
                testId="login-placeholder"
                title="Login"
                description="Supabase auth login will connect here."
              />
            }
          />
          <Route
            path="/terms"
            element={
              <PlaceholderPage
                testId="terms-placeholder"
                title="Terms of Service"
                description="Terms of service content will be added here."
              />
            }
          />
          <Route
            path="/privacy"
            element={
              <PlaceholderPage
                testId="privacy-placeholder"
                title="Privacy Policy"
                description="Privacy policy content will be added here."
              />
            }
          />
        </Routes>
      </main>
      <Footer />
      <CookieConsent />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppLayout />
      <Analytics />
    </BrowserRouter>
  );
}

export default App;
